export default __webpack_public_path__ + "static/media/pngtree-error-404-page-not-found.6c64b141.jpg";